import {addBrowserSideAppHeaders} from '@/utils/unityHeaders';
import {getUserId} from '@/services/internal/user/getUserId';
import {USER_ID_HEADER} from '@/utils/constant';
import {ProgressionValue} from '@/services/internal/progressions/types';

type GetProgressionUserData = {
  payload: Record<string, ProgressionValue>;
  key_namespace: string;
};

export async function getProgressionUserData(
  namespace: string = '',
  developerKeys: string[] = []
): Promise<GetProgressionUserData> {
  const headers = {};
  await addBrowserSideAppHeaders(headers);
  headers['User-Agent'] = navigator.userAgent;
  headers[USER_ID_HEADER] = getUserId();

  try {
    const response = await fetch(
      `/apigw/v1/progression_user_data/${namespace}?developer_keys=${developerKeys.join(',')}`,
      {
        method: 'GET',
        headers,
      }
    );
    if (!response.ok) {
      throw new Error('Failed to fetch user progression data');
    }
    return await response.json();
  } catch (e) {
    console.error('Error fetching progression user data:', e);
    throw e;
  }
}

export async function updateProgressionUserData({
  progressionNamespace,
  userDataUpdates,
}: {
  progressionNamespace: string;
  userDataUpdates: Record<string, string>;
}): Promise<'success' | 'failed'> {
  const headers = {
    'Content-Type': 'application/json',
  };
  await addBrowserSideAppHeaders(headers);
  headers['User-Agent'] = navigator.userAgent;
  headers[USER_ID_HEADER] = getUserId();
  try {
    const response = await fetch(`/apigw/v1/progression_user_data/${progressionNamespace}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(userDataUpdates),
    });

    if (!response.ok) {
      throw new Error('Failed to update user progression data');
    }

    return response.ok ? 'success' : 'failed';
  } catch (e) {
    console.error('Error updating progression user data:', e);
    throw e;
  }
}
